<button
	class="back-button"
	data-quat="action_backButton"
>
	<div
		role="presentation"
		class="back-button__icon-circle"
		[ngStyle]="{
			height: actualIconSize,
			width: actualIconSize
		}"
	>
		<svg
			viewBox="0 0 41 41"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				class="back-button__back-arrow"
				d="M21.855 14.533a1 1 0 0 0-1.414-1.414l1.414 1.414zm-7.374 5.96-.707-.707a1 1 0 0 0 0 1.414l.707-.707zm5.96 7.374a1 1 0 0 0 1.414-1.415l-1.414 1.415zm7.373-6.374a1 1 0 0 0 0-2v2zm-7.373-8.374-6.667 6.667 1.414 1.414 6.667-6.667-1.414-1.414zm-6.667 8.08 6.667 6.668 1.414-1.415-6.667-6.666-1.414 1.414zm.707.294h13.333v-2H14.481v2z"
			/>
		</svg>
	</div>
	<span>
		{{ label }}
	</span>
</button>
